import { TutorialService } from './../../Services/tutorial.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-tutorial-list',
  template: require('./tutorial-list.component.html'),
  styles: [require('./tutorial-list.component.css')]
})
export class TutorialListComponent implements OnInit {
  tutorials: any = [];
  // showVideo: boolean = false;
  videoWidth = "286";
  editItem: any = {};

  constructor(private tutorialService: TutorialService, private auth: AuthService  ) { 
    
  }

  ngOnInit() {
    // console.log("on ngInit tutorial -list");
    this.getAllTutorials();
  }

  private getAllTutorials(){
    this.tutorials = [];
    this.tutorialService.getAllTutorials().subscribe(res =>{
      
      this.tutorials = res;
      // console.log(this.tutorials);
      
    })
  }

  playMovie(id: string){
    // console.log(id);
    this.swapImageVideoforId(id);
    let elem =  document.getElementById("video-"+id);
    if (elem !=null){
      let video = <HTMLMediaElement> elem;
      video.play();
    }
  }

  videoEnded(id: string){
    // console.log('Video ended:'+id);
    this.swapImageVideoforId(id);

    // https://stackoverflow.com/questions/40535014/angular2-how-to-get-reference-of-html-elements-generated-dynamically/41306286
  }


  private swapImageVideoforId(id: string){
    let thumbnail_elem = document.getElementById("thumbnail-"+id);
    let video_elem = document.getElementById("video-"+id);
    let overlay_elem = document.getElementById("overlay-"+id)
    // console.log(thumbnail_elem);
    // console.log(video_elem);

    if (thumbnail_elem != null && video_elem != null && overlay_elem != null){
      thumbnail_elem.hidden = !thumbnail_elem.hidden;
      video_elem.hidden = !video_elem.hidden;
      overlay_elem.hidden = !overlay_elem.hidden;
    }
  }

  deleteTutorial(id: number){
    this.tutorialService.delete(id).subscribe( res =>{
      // console.log(res);
      var item = this.tutorials.find( (a:any)=> a.id == id);
      // console.log(item);
      
      if (item){
        const index = this.tutorials.indexOf(item, 0);
        if (index > -1) {
          this.tutorials.splice(index, 1);
        }
      }
    })
  }

  readMore(id: number){
    console.log(id);
    // console.log(this.tutorials);
    
    var item = this.tutorials.filter( (a:any) =>  a.id == id )

    if (item.length > 0){
      item = item[0]
    }

    // console.log(item);
    

    Swal.fire({
      title: "<i>"+item.title+"</i>", 
      html: item.content ,  
      confirmButtonColor: '#3085d6',
      confirmButtonText: "Ok", 
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/tutorial-list/tutorial-list.component.ts